// =========================================================
// fadeUp on scroll (IntersectionObserver)
// Gere aussi les elements injectes apres le chargement
// (scroll infini des collections, contenu ajax)
// =========================================================
(function() {
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.reveal').forEach(function(el) {
      el.classList.add('is-in');
    });
    return;
  }

  var io = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (!entry.isIntersecting) return;
      var target = entry.target;
      var parent = target.parentElement;
      var siblings = parent
        ? Array.prototype.slice.call(parent.querySelectorAll(':scope > .reveal'))
        : [];
      var idx = siblings.indexOf(target);
      var delay = idx >= 0 ? Math.min(idx * 100, 400) : 0;
      setTimeout(function() { target.classList.add('is-in'); }, delay);
      io.unobserve(target);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  function bind(el) {
    if (!el || el.nodeType !== 1 || el.dataset.revealBound) return;
    el.dataset.revealBound = '1';
    io.observe(el);
  }

  function scan(root) {
    var scope = (root && root.querySelectorAll) ? root : document;
    if (scope.classList && scope.classList.contains('reveal')) bind(scope);
    scope.querySelectorAll('.reveal').forEach(bind);
  }

  scan(document);

  var mo = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      Array.prototype.forEach.call(m.addedNodes, function(node) {
        if (node.nodeType === 1) scan(node);
      });
    });
  });

  function startMO() {
    if (!document.body) {
      document.addEventListener('DOMContentLoaded', startMO);
      return;
    }
    mo.observe(document.body, { childList: true, subtree: true });
  }
  startMO();

  window.vdnRevealScan = scan;
})();

// =========================================================
// FAQ accordion
// =========================================================
document.querySelectorAll('.faq-q').forEach(btn => {
  btn.addEventListener('click', () => {
    const item = btn.parentElement;
    const isOpen = item.classList.contains('is-open');
    // close siblings in same panel
    item.parentElement.querySelectorAll('.faq-item.is-open').forEach(it => it.classList.remove('is-open'));
    if (!isOpen) item.classList.add('is-open');
  });
});

// =========================================================
// Count-up animation on stats numbers
// =========================================================
(function() {
  const counters = document.querySelectorAll('.count-up');
  if (!counters.length) return;
  const easeOutCubic = t => 1 - Math.pow(1 - t, 3);
  function format(value, opts) {
    if (opts.decimals > 0) {
      return value.toFixed(opts.decimals).replace('.', ',');
    }
    const intVal = Math.round(value);
    if (opts.format === 'space') {
      return intVal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '\u202F');
    }
    return intVal.toString();
  }
  function animate(el) {
    const target = parseFloat(el.dataset.target);
    const duration = parseInt(el.dataset.duration || '1400', 10);
    const decimals = parseInt(el.dataset.decimals || '0', 10);
    const fmtOpts = { decimals, format: el.dataset.format };
    const start = performance.now();
    function step(now) {
      const t = Math.min((now - start) / duration, 1);
      const value = target * easeOutCubic(t);
      el.textContent = format(value, fmtOpts);
      if (t < 1) requestAnimationFrame(step);
      else el.textContent = format(target, fmtOpts);
    }
    requestAnimationFrame(step);
  }
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    counters.forEach(el => {
      const target = parseFloat(el.dataset.target);
      const decimals = parseInt(el.dataset.decimals || '0', 10);
      el.textContent = format(target, { decimals, format: el.dataset.format });
    });
    return;
  }
  const co = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        animate(e.target);
        co.unobserve(e.target);
      }
    });
  }, { threshold: 0.4 });
  counters.forEach(el => co.observe(el));
})();

// =========================================================
// Product carousels : arrow navigation
// =========================================================
(function() {
  const carousels = document.querySelectorAll('.carousel-wrap');
  carousels.forEach(wrap => {
    const track = wrap.querySelector('.product-carousel');
    const prev = wrap.querySelector('.carousel-nav--prev');
    const next = wrap.querySelector('.carousel-nav--next');
    if (!track || !prev || !next) return;

    function updateNav() {
      const max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }
    function scrollBy(dir) {
      const first = track.querySelector('.product');
      if (!first) return;
      const cardW = first.getBoundingClientRect().width + 20; // gap
      track.scrollBy({ left: dir * cardW * 2, behavior: 'smooth' });
    }
    prev.addEventListener('click', () => scrollBy(-1));
    next.addEventListener('click', () => scrollBy(1));
    track.addEventListener('scroll', updateNav, { passive: true });
    window.addEventListener('resize', updateNav);
    updateNav();
  });
})();

// =========================================================
// FAQ tabs
// =========================================================
document.querySelectorAll('.faq-tab').forEach(tab => {
  tab.addEventListener('click', () => {
    const target = tab.dataset.tab;
    document.querySelectorAll('.faq-tab').forEach(t => t.classList.toggle('is-active', t === tab));
    document.querySelectorAll('.faq-panel').forEach(p => p.classList.toggle('is-active', p.dataset.panel === target));
    // close any open item in newly active panel
    document.querySelectorAll('.faq-item.is-open').forEach(it => it.classList.remove('is-open'));
  });
});

// Quiz chips V5
document.querySelectorAll('.quiz-chip-v5').forEach(chip => {
  chip.addEventListener('click', () => {
    chip.closest('.quiz-chips-v5').querySelectorAll('.quiz-chip-v5')
        .forEach(c => c.classList.remove('quiz-chip-v5--active'));
    chip.classList.add('quiz-chip-v5--active');
  });
});
